import { render, staticRenderFns } from "./BankSuggestedCostTable.vue?vue&type=template&id=569b052d&scoped=true&"
import script from "./BankSuggestedCostTable.vue?vue&type=script&lang=js&"
export * from "./BankSuggestedCostTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569b052d",
  null
  
)

export default component.exports